// eslint-disable-next-line
module.exports = require('./dist/es5/constants');